import {loadScriptOnce} from './utils';

document.addEventListener('DOMContentLoaded', () => {
  loadScriptOnce('/local/templates/template3/public/js/vendor/jquery-3.2.1.min.js', function () {
    const $ = window.jQuery || window.$;

    if (!$) return;

    // scroll to element
    (function () {
      var $scrollEls = $('[data-scroll-to]');

      if (!$scrollEls.length) return;

      $scrollEls.each(function () {
        var $el = $('#' + $(this).data('scroll-to'));

        if (!$el.length) return;

        $(this).on('click', function () {
          $('html, body').stop().animate({
            scrollTop: $el.offset().top
          }, 1200);

          return false;
        });
      });
    }());

    // scroll-to
    (function () {
      const MOBILE_VERSION = 991;
      var $scroll = $('[data-scroll-down]');
      $scroll.each(function () {
        var $this = $(this);
        if ($this.attr('data-scroll-down') === 'about' && window.innerWidth <= MOBILE_VERSION) return;
        $this.on('click', function () {
          var nameAttr = $(this).data('scrollDown');
          var $scrollSection = $('[data-scroll-section="' + nameAttr + '"]');
          if ($scrollSection.length) {
            var closestSectionHeight = $('.header').height() || 0,
              closestSectionBottomPosition = ($scrollSection.offset().top - closestSectionHeight);
            $('html, body').animate({scrollTop: (closestSectionBottomPosition)}, 800);
          }
        });
      });
    }());

    // header scroll
    (function () {
      const $html = $('html');
      const $page = $('.b-page');
      const $panel = $('.panel');
      const $header = $('.header');
      const $window = $(window);

      function toggleClass() {
        $header.toggleClass('-scroll');
        $panel.toggleClass('-scroll');
      }

      function getOffset() {
        return $header.height();
      }

      function scrolling() {
        if ($html.hasClass('safari')) {
          $html.css('--scroll-y', `-${window.scrollY}px`);
        }

        if ($(window).scrollTop() > getOffset() && !$header.hasClass('-scroll') && !$page.hasClass('-open-menu')) {
          toggleClass();
        } else if ($(window).scrollTop() < getOffset() && $header.hasClass('-scroll') && !$page.hasClass('-open-menu')) {
          toggleClass();
        }
      }

      $window.on('load scroll', scrolling);
    })();
  });
})
